import { render, staticRenderFns } from "./Form1QualifyQuestions.vue?vue&type=template&id=5c2d1940&scoped=true"
import script from "./Form1QualifyQuestions.vue?vue&type=script&lang=ts"
export * from "./Form1QualifyQuestions.vue?vue&type=script&lang=ts"
import style0 from "./Form1QualifyQuestions.vue?vue&type=style&index=0&id=5c2d1940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d1940",
  null
  
)

export default component.exports